module.exports = __webpack_public_path__ + "static/Chicory6-8573906931a42006229a80ca033e6696.webp";